import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import styled from 'styled-components';
import { Button } from '@zocdoc-frontend-common/components-button';
import { white } from '@zocdoc/branding/colors';

class BaseSocialLoginButton extends PureComponent {
    static propTypes = {
        className: PropTypes.string,
        icon: PropTypes.func.isRequired,
        message: PropTypes.string.isRequired,
        onClick: PropTypes.func,
    };

    render() {
        const { className, icon: Icon, message, onClick } = this.props;

        return (
            <StyledButton className={className} fluid onClick={onClick}>
                {message}
                <IconContainer>
                    <Icon />
                </IconContainer>
            </StyledButton>
        );
    }
}

export const IconContainer = styled.div`
    align-items: center;
    display: flex;
    height: 48px;
    justify-content: center;
    position: absolute;
    top: 0;
    width: 52px;
`;

export const StyledButton = styled(Button)`
    border: none;
    color: ${white};
    font-size: 18px;
    height: 48px;
    outline: none;
    padding: 0;
    position: relative;

    &:hover,
    &:active {
        cursor: pointer;
    }
`;

export default BaseSocialLoginButton;
